import {handleApiError, itemEmpty, itemPayload} from './common.js'
import editItem from './edit-item.js'

export default function create(resource, apiDefinition) {
  const SET_ERROR = 'SET_ERROR'

  const operation = resource.operations.create
  const properties = operation.input.properties

  return editItem({
    state: {
      error: '',
    },
    actions: {
      clear: ({dispatch}) => {
        return dispatch('setItem', itemEmpty(properties))
      },
      save: ({ commit, dispatch, getters }) => {
        if (getters.item['id']) {
          throw new Error('Create store must be cleared after save before a new item may be saved.')
        }
        commit(SET_ERROR, '')

        return new Promise((resolve, reject) => {
          dispatch('api/post', { uri: operation.url, options: {
              body: JSON.stringify(itemPayload(properties, getters.item))
            }}, { root: true })
            .then(response => response.json())
            .then((data) => {
              commit(SET_ERROR, '')
              Promise.all([
                dispatch('setViolations', null),
                dispatch('setItem', data)
              ]).then(() => {
                resolve(data)
              }).catch(e => {
                reject(e)
              })
            })
            .catch((error) => {
              handleApiError({commit, dispatch}, error)
              reject(error)
            })
        })
      },
    },
    getters: {
      error: state => state.error,
    },
    mutations: {
      [SET_ERROR] (state, error) {
        Object.assign(state, { error })
      },
    }
  }, properties, apiDefinition)
}
